<template>
  <v-container class="customer-detail">
    <h2 class="title">Customer Details</h2>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <v-text-field
          v-model="customer.fullname"
          :rules="[rules.required]"
          label="Full Name"
          required
          outlined
          readonly
          disabled
          hide-details
        ></v-text-field>
      </v-col>

      <v-col
        cols="12"
        md="3"
      >
        <v-text-field
          v-model="customer.email"
          :rules="[rules.required, rules.email]"
          label="Email"
          required
          type="email"
          outlined
          readonly
          disabled
          hide-details
        ></v-text-field>
      </v-col>

      <v-col
        cols="12"
        md="3"
      >
        <v-text-field
          v-model="customer.phone"
          :rules="[rules.required]"
          label="Phone"
          required
          type="tel"
          outlined
          readonly
          disabled
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <v-text-field
          v-model="customer.street"
          label="Street"
          :rules="[rules.required]"
          required
          outlined
          readonly
          disabled
          hide-details
        ></v-text-field>
      </v-col>

      <v-col
        cols="12"
        md="3"
      >
        <v-text-field
          v-model="customer.city"
          :rules="[rules.required]"
          label="City"
          required
          outlined
          readonly
          disabled
          hide-details
        ></v-text-field>
      </v-col>

      <v-col
        cols="12"
        md="3"
      >
        <v-text-field
          v-model="customer.zipcode"
          :rules="[rules.required]"
          label="Zipcode"
          required
          type="tel"
          outlined
          readonly
          disabled
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <h2 class="title">Cars Details</h2>
    <div v-for="(car, i) in cars" :key="`car-${i}`">
      <CustomerCar 
        :car=car 
        :rules=rules 
        :i=i
        :disabled=true
      />
    </div>
    <div class="mb-5">
      <v-btn
        color="primary"
        class="mr-4"
        :to="`/customers/edit/${$route.params.id}`"
      >
        Edit Customer
      </v-btn>
    </div>
    <h2 class="title">Sales</h2>
    <v-data-table 
      :headers="headers"
      :items="sales" 
      :loading="loading"
    >
      <template v-slot:item.action="{ item }">
        <v-btn icon text :to="`/sales/edit/${item.id}`" class="mr-1">
          <v-icon small>visibility</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import CustomerCar from "./CustomerCar"
import api from "@/api";
const car = {
  make: '',
  model: '',
  year: '',
  vin: '',
}
export default {
  name: "CustomerDetail",
  components: {
    CustomerCar
  },
  data: () => ({
    loading: false,
    customer: {
      fullname: '',
      email: '',
      phone: '',
      street: '',
      city: '',
      zipcode: '',
    },
    headers: [
      { text: 'Date', value: 'date' },
      { text: 'Total', value: 'total' },
      { text: 'Actions', value: 'action', sortable: false },
    ],
    cars: [{
      ...car
    }],
    sales: [],
    rules: {
      required: v => !!v || 'Name is required',
      email: v => /.+@.+/.test(v) || 'E-mail must be valid',
      max: (len) => v => v.length <= len || `Must be less than ${len} characters`,
    }
  }),
  methods: {

    async getCustomer(id) {
      try {
        this.loading = true;
        const { data } = await api.getCustomer(id);
        this.customer = data.customer;
        this.cars = data.cars;
        this.sales = data.sales;
      } catch (error) {
        this.$toast.error("Error Finding Customer");
      }
      this.loading = false;
    },
    
  },
  mounted() {
    if(this.$route.params && this.$route.params.id) {
      this.getCustomer(this.$route.params.id);
    }
  }
};
</script>
<style lang="scss">
.customer-detail {
  & input , .v-label, .v-select__selection{
    color: #000 !important;
  }
}
</style>